(function () {
  function initBdSetContents() {
    document.querySelectorAll('[data-bd-set-contents]').forEach(function (container) {
      if (container.hasAttribute('data-bd-set-initialized')) return;
      container.setAttribute('data-bd-set-initialized', '');

      var modals = container.querySelectorAll('[data-bd-set-modal]');
      var triggers = container.querySelectorAll('[data-bd-set-modal-trigger]');

      var closeModal = function (modal) {
        modal.classList.remove('is-open');
        document.body.classList.remove('bd-set-modal-open');
      };

      var openModal = function (modalId) {
        modals.forEach(function (modal) {
          if (modal.dataset.bdSetModal === modalId) {
            modal.classList.add('is-open');
          } else {
            modal.classList.remove('is-open');
          }
        });
        document.body.classList.add('bd-set-modal-open');
      };

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var modalId = trigger.dataset.bdSetModalTrigger;
          if (modalId) openModal(modalId);
        });
      });

      container.querySelectorAll('[data-bd-set-modal-close]').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () {
          var modal = closeBtn.closest('[data-bd-set-modal]');
          if (modal) closeModal(modal);
        });
      });

      container.querySelectorAll('[data-bd-set-modal-overlay]').forEach(function (overlay) {
        overlay.addEventListener('click', function () {
          var modal = overlay.closest('[data-bd-set-modal]');
          if (modal) closeModal(modal);
        });
      });

      container.querySelectorAll('[data-bd-set-accordion-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = trigger.nextElementSibling;
          if (!panel || !panel.hasAttribute('data-bd-set-accordion-panel')) return;
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', String(!isOpen));
          panel.classList.toggle('is-open', !isOpen);
        });
      });
    });
  }

  window.__initBdSetContents = initBdSetContents;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBdSetContents);
  } else {
    initBdSetContents();
  }
})();
